import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service';
import { messages } from './messages';

export const AddressLine2 = {
  id: 'addressLine2',
  type: OptionFormTypes.TYPE_STRING,
  filterValue: 'AddressLine2',
  displayName: <FormattedMessage {...messages.addressLine2} />,
  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_STRING, criteriaInformations);
  },
};
